// extracted by mini-css-extract-plugin
module.exports = {"content":"ProductInfo_content__12vY4","modal":"ProductInfo_modal__1t9QN","field":"ProductInfo_field__3hZ40","footer":"ProductInfo_footer__qKICe"};